// import primary libraries
import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import moment from 'moment';

// import siteLocation css modules
import siteLocationStyles from '../siteLocationModuleStyles.css';

const SiteLocationListItem = ({ 
  selectAction
  , siteLocation 
  , url 
}) => {
  if(selectAction) {
    return (
      <div onClick={selectAction} className="-site-location-list-item -selectable">
        <div className="-icon">
          <i className="-fal fa-circle 2x"/>
        </div>
        <div className="-location-info">
          {/* <small className="u-pullRight u-muted"><em>Created: {moment(siteLocation.created).format("MM/DD/YYYY")}</em></small> */}
          <p><strong><small>{siteLocation.name}</small></strong></p>
          { siteLocation.address 
            && siteLocation.address.city 
            && <p><small>{siteLocation.address.street1} {siteLocation.address.street2 && <span> {siteLocation.address.street2} </span> } {siteLocation.address.city}, {siteLocation.address.state} {siteLocation.address.postal} {siteLocation.address.country}</small></p>
          } 
        </div>
      </div>
    )
  } else if(url) {
    return (
      <Link to={url} className="-site-location-list-item -linkable">
        <div className="-location-info">
          {/* <small className="u-pullRight u-muted"><em>Created: {moment(siteLocation.created).format("MM/DD/YYYY")}</em></small> */}
          <p><strong><small>{siteLocation.name}</small></strong></p>
          { siteLocation.address 
            && siteLocation.address.city 
            && <p><small>{siteLocation.address.street1} {siteLocation.address.street2 && <span> {siteLocation.address.street2} </span> } {siteLocation.address.city}, {siteLocation.address.state} {siteLocation.address.postal} {siteLocation.address.country}</small></p>
          } 
        </div>
      </Link>
    )
  } else {
    return (
      <div className="-site-location-list-item">
        <div className="-location-info">
          {/* <small className="u-pullRight u-muted"><em>Created: {moment(siteLocation.created).format("MM/DD/YYYY")}</em></small> */}
          <p><strong><small>{siteLocation.name}</small></strong></p>
          { siteLocation.address 
            && siteLocation.address.city 
            && <p><small>{siteLocation.address.street1} {siteLocation.address.street2 && <span> {siteLocation.address.street2} </span> } {siteLocation.address.city}, {siteLocation.address.state} {siteLocation.address.postal} {siteLocation.address.country}</small></p>
          } 
        </div>
      </div>
    )
  }
}

SiteLocationListItem.propTypes = {
  selectAction: PropTypes.func 
  , siteLocation: PropTypes.object.isRequired
  , url: PropTypes.string 
}

SiteLocationListItem.defaultProps = {
  selectAction: null 
  , url: ''
}

export default SiteLocationListItem;



// WEBPACK FOOTER //
// modules/siteLocation/components/SiteLocationListItem.js.jsx